import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { Button, DialogAlert, DialogModal, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Article } from '@component/article.component';
import { useState } from 'react';

export function AuthSignInError() {
	const queryParams = new URLSearchParams(window.location.search);
	const [dialogOpen, setDialogOpen] = useState(true);
	let isClosable = false;

	if (queryParams.get('access_denied') !== '1') {
		return null;
	}

	let descriptionKey: I18nAndL10n.LocaleKey = 'Component.SignInError.Description.Default';

	if (queryParams.get('error_description') === 'ConsentNotGiven') {
		if (queryParams.get('remote_scheme') === 'nhs') {
			descriptionKey = 'Component.SignInError.nhs.Description.ConsentNotGiven';
			isClosable = true;
		}
	}

	return (
		<DialogModal.Root
			open={dialogOpen}
			onOpenChange={setDialogOpen}
			onOpenAutoFocus={(e) => e.preventDefault()}
			onCloseAutoFocus={(e) => e.preventDefault()}
			closeable={!isClosable}
			onInteractOutside={isClosable ? (e) => e.preventDefault() : undefined}
			onPointerDownOutside={isClosable ? (e) => e.preventDefault() : undefined}
		>
			<DialogModal.Content>
				<Flex grow='1' gap={tokens.spacing.x2}>
					<DialogModal.Title>{withTranslation('Component.SignInError.Title')}</DialogModal.Title>
				</Flex>
				<Article>{withTranslation(descriptionKey)}</Article>
			</DialogModal.Content>
			<DialogModal.Footer>
				{!isClosable ? (
					<Button type='button' style={{ float: 'right' }} onClick={() => setDialogOpen(false)}>
						{withTranslation('Common.Button.Close')}
					</Button>
				) : null}
			</DialogModal.Footer>
		</DialogModal.Root>
	);
}
